import { render, staticRenderFns } from "./WidgetAbout.vue?vue&type=template&id=43d26dbe"
import script from "./WidgetAbout.vue?vue&type=script&lang=js"
export * from "./WidgetAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports